<template>
  <div class="content">
    <div class="card">
      <div class="card-item">
        <div class="title">草场</div>
        <div class="img-icon">
          <img src="../../../../../assets/back/oper-icon1.png" alt="" />
        </div>
        <div class="value-box">
          <div class="value-box-label" style="margin-top: 0.6rem">
            <span>租赁草场：</span>
            <span>{{ infoObj?.meadowLease||0}}</span>
            <span>亩</span>
          </div>
          <div class="value-box-value">
            <span>较上次巡检</span>
            <span>{{ infoObj?.addMeadowLease||0}}</span>
            <span>亩</span>
          </div>
          <div class="value-box-label" style="margin-top: 0.4rem">
            <span>自有草场：</span>
            <span>{{ infoObj?.meadowOwn||0}}</span>
            <span>亩</span>
          </div>
          <div class="value-box-value">
            <span>较上次巡检</span>
            <span>{{ infoObj?.addMeadowOwn||0}}</span>
            <span>亩</span>
          </div>
        </div>
      </div>

      <div class="card-item">
        <div class="title">棚圈</div>
        <div class="img-icon">
          <img src="../../../../../assets/back/oper-icon2.png" alt="" />
        </div>
        <div class="value-box">
          <div class="value-box-label" style="margin-top: 0.6rem">
            <span>租赁棚圈：</span>
            <span>{{ infoObj?.penLease||0}}</span>
            <span>亩</span>
          </div>
          <div class="value-box-value">
            <span>较上次巡检</span>
            <span>{{ infoObj?.addPenLease||0}}</span>
            <span>亩</span>
          </div>
          <div class="value-box-label" style="margin-top: 0.4rem">
            <span>自有棚圈：</span>
            <span>{{ infoObj?.penOwn||0}}</span>
            <span>亩</span>
          </div>
          <div class="value-box-value">
            <span>较上次巡检</span>
            <span>{{ infoObj?.addPenOwn||0}}</span>
            <span>亩</span>
          </div>
        </div>
      </div>
      <div class="card-item">
        <div class="title">装机设备</div>
        <div class="img-icon">
          <img src="../../../../../assets/back/oper-icon3.png" alt="" />
        </div>
        <div class="value-box">
          <div class="value-box-value device" style="margin-top: 0.6rem">
            <div class="icon-box" v-for="item in deviceList" :key="item.id">
              <img v-if="item.checked" src="../../../../../assets/back/check.png">
              <div v-if="!item.checked" class="default-box"></div>
              <div class="check-label" :class="!item.checked? 'default-check ?': ''">{{ item.label }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-item">
        <div class="title">家庭情况</div>
        <div class="img-icon">
          <img src="../../../../../assets/back/oper-icon4.png" alt="" />
        </div>
        <div class="value-box">
          <div class="value-box-value" style="margin-top: 0.6rem">
            <div class="special">
              <div>特殊情况发生：<span class="special-value">{{ infoObj?.specialType==0?'无':'有' }}</span></div>
              <!-- <div class="special-detail">情况说明：<span>被起诉</span></div> -->
            </div>
            <div class="loan">
              新增贷款 ：
              <span class="loan-value">{{infoObj?.newlyLoansAmount||0}}</span>
              万
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props:{
    loanYearQuery:{
        type:Object,
    }
  },
  data() {
    return {
      deviceList: [
          {id: 18, label: '搅拌机', checked: false},
          {id: 19, label: '撒料车', checked: false},
          {id: 20, label: '打草机', checked: false},
          {id: 21, label: '捆草机', checked: false},
          {id: 22, label: '铲车', checked: false},
      ],
      infoObj:{}
    }
  },
  
watch:{
    'loanYearQuery':{
        handler(){
            this.getInfo()
        },
        immediate:true,
        deep:true
    }
},

  created() {},
  mounted() {},

  methods: {
    getInfo(){
      
        this.$http({
            url: 'ffsapp-service/superviseProperty/queryBusinessStatistics',
			method: 'post',
            data:this.loanYearQuery
        }).then((res)=>{
            this.infoObj=res.data.result||{}
            if(this.infoObj?.mechanical){
               let arry= this.infoObj?.mechanical?.split(',')
              // this.deviceList.forEach((item)=>{
              //   if(arry.indexOf(item.id.toString())>=0){
              //       item.checked=true
              //   }else{
              //     console.log(item.id);
              //     item.checked=false
              //   }
              //  })
              if(!arry) return
              arry.forEach(id =>{
                let item = this.deviceList.find(item => item.id == id)
                if(item){
                  item.checked = true;
                }
              })
            }
        })
    }
  },
}
</script>

<style scoped lang="scss">
.content {
  .card {
    width: 100%;
    height: 3.6625rem;
    margin-top: 0.6rem;
    display: flex;
    justify-content: space-between;
    &-item {
      width: 2.375rem;
      height: 100%;
      background: linear-gradient(154deg, rgba(255, 255, 255, 0.01) 0%, rgba(255, 255, 255, 0.06) 57%, rgba(255, 255, 255, 0.01) 100%);
      border-radius: 0.0125rem;
      box-sizing: border-box;
      padding: 0.1875rem;
      .title {
        width: 100%;
        height: 0.175rem;
        color: #fff;
        font-size: 0.2rem;
        font-weight: 400;
      }
      .img-icon {
        width: 0.6125rem;
        height: 0.68rem;
        margin: 0.175rem auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .value-box {
        width: 100%;
        height: 2rem;
        //  background-color: antiquewhite;
        margin-top: 0.35rem;
        &-label {
          span:nth-child(2n-1) {
            font-size: 0.15rem;
            font-family: Source Han Sans, Source Han Sans;
            font-weight: 400;
            color: #ffffff;
          }
          span:nth-child(1) {
            display: inline-block;
            width: .75rem;
          }
          span:nth-child(even) {
            font-size: 0.25rem;
            font-family: DIN, DIN;
            font-weight: 700;
            color: #efab44;
            margin: 0.05rem;
          }
        }
        &-value {
          margin-top: 0.125rem;
          span:nth-child(2n-1) {
            font-size: 0.125rem;
            font-family: Source Han Sans, Source Han Sans;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.5);
          }
          span:nth-child(1) {
            display: inline-block;
            width: .75rem;
          }
          span:nth-child(even) {
            font-size: 0.125rem;
            font-family: Source Han Sans, Source Han Sans;
            font-weight: 400;
            color: #9de045;
            margin: 0.05rem;
          }
          .icon-box{
            width: 50%;
            height: .175rem;
            // background: #0DD3DD;
            margin-bottom: 30px;
            display: flex;
            align-items: center;
            img{
              width: .125rem;
              height: .125rem;
            }
            .default-box{
              width: .125rem;
              height: .125rem;
              border: .0125rem solid rgba(255,255,255,0.5);
              border-radius: .0125rem;
            }
            .check-label{
              font-size: .15rem;
              font-weight: 400;
              color: #EFAB44;
              margin-left: .125rem;
            }
            .default-check{
              font-size: .15rem;
              font-weight: 400;
              color: rgba(255,255,255,0.5);
            }
          }
          .special{
            width: 100%;
            height: 1.1rem;
            font-size: .15rem;
            font-family: Source Han Sans, Source Han Sans;
            font-weight: 400;
            color: #FFFFFF;
            .special-value{
              font-size: .25rem;
              font-family: DIN, DIN;
              font-weight: 700;
              color: #EFAB44;
            }
            .special-detail{
              width: 100%;
              height: .1875rem;
              font-size: .125rem;
              font-family: Source Han Sans, Source Han Sans;
              font-weight: 400;
              color: rgba(255,255,255,0.5);
              margin-top: .2rem;
              span{
                color: rgba(239, 171, 68, 1);
              }
            }
          }
          .loan{
            font-size: .15rem;
            font-family: Source Han Sans, Source Han Sans;
            font-weight: 400;
            color: #FFFFFF;
            .loan-value{
              font-size: .25rem;
              font-family: DIN, DIN;
              font-weight: 700;
              color: #EFAB44;
              display: inline;
            }
          }

        }
        .device{
          display: flex;
          flex-wrap: wrap;
        }
      }
    }
  }
}
</style>
